<template>
    <Dialog :visible="visible" class="dialog-container custom-dialog" modal :style="{ width: '30rem' }" :closable="false">
        <div class="header-container">
            <span class="title-dialog">Traitement du blacklisting</span>
        </div>

        <div class="form-container mt-3">
            <FormKit
                type="form"
                id="changeBlackListStateFormModal"
                @submit="onSubmitForm"
                :actions="false"
                incomplete-message="Désolé, tous les champs ne sont pas remplis correctement."
                #default="{ state: { valid } }"
            >
                <div class="row mt-5">
                    <div class="col">
                        <label class="form-check-label fw-bold">Etat :</label>
                        <div class="w-100 mb-4"></div>
                        <FormKit type="radio"
                                 name="isBlackListed"
                                 v-model="formData.isBlackListed"
                                 class="form-check-inline"
                                 :options="formOptions"
                                 :help="setHelp"
                        />
                    </div>
                    <div class="w-100"></div>
                    <div class="col">
                        <label class="form-check-label fw-bold mb-3" for="comment">
                            Commentaire <span style="color:red;">*</span> :
                        </label>
                        <FormKit type="textarea"
                                 name="comment"
                                 class="form-comment"
                                 validation="required|length:1,255|isCommentNotEmpty"
                                 :validation-rules="{ isCommentNotEmpty }"
                                 :validation-messages="{
                                    required: 'Veuillez entrer une description.',
                                    length: 'Ce champ doit contenir maximum 255 caractères.',
                                    isCommentNotEmpty: 'Veuillez entrer une description.',
                            }"
                        />
                    </div>
                </div>

                <div class="footer-container">
                    <FormKit type="button"
                             label="Annuler"
                             @click="closeDialog"
                             class="mr-2"
                             style="background-color: #ff4d4d; color: white;"
                    />
                    <FormKit type="submit" label="Valider" :disabled="!valid || isFormSubmitting"/>
                </div>
            </FormKit>
        </div>
    </Dialog>
</template>

<script lang="ts" setup>
import {editBlacklistState} from "@/_services/blackList/blacklist";
import {UserBlacklistHistorique} from "@/models/blacklisting/UserBlacklistHistorique";
import {useAuthStore} from "@/stores/auth/authStore";
import {ref, computed, PropType, defineEmits, reactive} from "vue";
import swal from "@/_helpers/swal";
import Dialog from 'primevue/dialog';
import {useRouter} from "vue-router";
import {useRoute} from 'vue-router';

const router = useRouter();
const route = useRoute();
const authStore = useAuthStore();
const emit = defineEmits(['confirm', 'update:visible']);
const props = defineProps({
    historiqueBlacklist: {
        type: Object as PropType<UserBlacklistHistorique>,
        required: true,
    },
    visible: {
        type: Boolean,
        required: true,
        default: false,
    },
    allowBlacklistOnly: {
        type: Boolean,
        required: false,
        default: false,
    },
});

const isFormSubmitting = ref<boolean>(false);
const BLACKLIST_OPTION_VALUE = "0";
const WHITELIST_OPTION_VALUE = "1";
type TypeBlacklistValue = "0" | "1" | null;
const blacklistValue = ref<TypeBlacklistValue>(null);
const historiqueBlacklist = computed(() => props.historiqueBlacklist);
blacklistValue.value = historiqueBlacklist.value.active ? BLACKLIST_OPTION_VALUE : WHITELIST_OPTION_VALUE;

const formOptions = [
    {
        label: "Blacklister - L'utilisateur sera bloqué et ne pourra plus se connecter à son compte.",
        value: BLACKLIST_OPTION_VALUE
    },
];

if (false === props.allowBlacklistOnly) {
    formOptions.push({
        label: "Whitelister - L'utilisateur peut de nouveau se connecter à son compte.",
        value: WHITELIST_OPTION_VALUE
    });
}

if (true === props.allowBlacklistOnly) {
    blacklistValue.value = BLACKLIST_OPTION_VALUE;
}

const setHelp = computed(() => {
    return formData.isBlackListed === BLACKLIST_OPTION_VALUE
        ? "L'utilisateur sera bloqué et ne pourra plus se connecter à son compte."
        : "L'utilisateur peut de nouveau se connecter à son compte.";
});

const isCommentNotEmpty = (node): boolean => {
    let comment= node.value;
    const regex = new RegExp(/\S/);
    
    return regex.test(comment);
};

const closeDialog = (): void => {
    emit('update:visible', false);
    resetFormData();
};

const formData = reactive({
    comment: '',
    isBlackListed: blacklistValue.value
});

const resetFormData = (): void => {
    formData.comment = '';
    formData.isBlackListed = blacklistValue.value ?? BLACKLIST_OPTION_VALUE;
};

const onSubmitForm = async (formData: object, formNode) => {
    isFormSubmitting.value = true;
    const currentUserAdminUuid = authStore.getCurrentUserUuid();
    if (currentUserAdminUuid) {
        editBlacklistState(
            historiqueBlacklist.value.uuid,
            formData.isBlackListed === BLACKLIST_OPTION_VALUE,
            formData.comment
        )
            .then((result: boolean) => {
                if (result) {
                    ('UserBlacklistHistorique' === route.name)
                        ? window.location.reload()
                        : router.push({ name: 'UserBlacklistHistorique', params: { uuid: historiqueBlacklist.value?.uuid } });
                } else {
                    isFormSubmitting.value = true;
                    swal.error("Le traitement a echoué");
                }
            })
            .catch((error) => {
                isFormSubmitting.value = true;
                console.dir(error);
                swal.error("Le traitement a echoué");
            });
    }
};
</script>

<style scoped lang="scss">
.footer-container {
    display: flex;
    justify-content: end;
    gap: 0.5rem;
}
.title-dialog {
    font-size: 18px;
    text-transform: uppercase;
    color: #0A3382;
    position: relative;
    margin-bottom: 30px;
    &:after {
        content: "";
        background: #f5a22e;
        width: 35px;
        height: 3px;
        position: absolute;
        bottom: -10px;
        left: 0;
        display: block;
    }
}
</style>